import AppSettings from "./AppSettings";
import ThemeSettings from "./ThemeSettings";
import HomeVoltage from "./HomeVoltage";
import Subscription from "./Subscription";
import HomeAddress from "./HomeAddress";
import { APP_SETTINGS_PATHS } from "./paths";

export { APP_SETTINGS_PATHS };

// The Settings screens from the side menu.
export const APP_SETTINGS_ROUTES = [
  { path: APP_SETTINGS_PATHS.HOME, component: AppSettings },
  { path: APP_SETTINGS_PATHS.THEME, component: ThemeSettings },
  { path: APP_SETTINGS_PATHS.VOLTAGE, component: HomeVoltage },
  { path: APP_SETTINGS_PATHS.SUBSCRIPTION, component: Subscription },
  { path: APP_SETTINGS_PATHS.HOME_ADDRESS, component: HomeAddress },
];
